module.exports = __webpack_public_path__ + "static/x4e-1f9565165bf5527839b45d7323e4911b.png";